export default {"src":"https://static.eleduck.com/_next/static/media/featured.f47e0b07.svg","height":15,"width":11,"blurWidth":0,"blurHeight":0};